<template>
    <div class="o-crops">
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <div class="l-row m-card__container">
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Nazwa paczki"
                        placeholder="Znajdź..."
                        name="agriiProtectors"
                        model-name="agriiProtectors"
                        @input="build('name', $event)"
                        :value="query['name']"
                    />
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Uprawa"
                        placeholder="Znajdź..."
                        name="agriiProtectorsCrop"
                        model-name="agriiProtectorsCrop"
                        @input="build('crops', $event)"
                        :value="query['crops']"
                    />
                </div>
            </div>
        </div>
        <o-list
            vuex-action-fetch="fetchAgriiProtectors"
            vuex-action-fetch-next-page="fetchAgriiProtectorsNextPage"
            vuex-getter-model="agriiProtectors"
            vuex-getter-status="agriiProtectorsStatus"
            router-single-name="agrii-protector"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="props.list.item.photos && props.list.item.photos.length > 0 && !!props.list.item.photos.find(item => item.is_main === true)"
                        :src="props.list.item.photos.find(item => item.is_main === true).full_uri"
                        :alt="props.list.item.name"
                    />
                    <figure
                        v-else
                        class="a-image"
                    ></figure>
                </div>
                <p
                    class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                    :style="authIsAdvisor && props.list.item.position_group ? { color: props.list.item.position_group.hex } : false"
                >
                    {{ props.list.item.name }}
                </p>
                <div class="m-list__itemIcons">
                    <a-icon
                        v-if="props.list.item.youtube_link"
                        class="m-list__icon"
                        icon="Video"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.notes && props.list.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                    />
                </div>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Środki'
    },
    computed: {
        query() {
            return this.$store.getters.agriiProtectorsQuery
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setAgriiProtectorsSearchQuery', {
                name,
                value
            }).then(() => {
                this.$store.dispatch('fetchAgriiProtectors').catch(() => {})
            })
        }
    },
    created() {
        this.$store.dispatch('resetAgriiProtectorsFavorite')
    }
}
</script>
